import { BottomSheet, Button, Flex, Text } from 'components/InterUI/InterUI'

interface Props {
  handleCloseBottomSheet: () => void
}

export const PaymentProcessingBottomSheet = ({ handleCloseBottomSheet }: Props) => (
  <BottomSheet onClose={handleCloseBottomSheet}>
    <Flex direction="column" gap="16px" data-testid="payment-processing-bottom-sheet">
      <Text variant="headline-h3" as="h3" semiBold>
        Pagamento pendente
      </Text>
      <Text variant="body-3" colorWeight={400}>
        Seus títulos estão pendentes de pagamento porque não encontramos saldo suficiente na sua
        conta. Certifique-se de que tem o valor necessário para continuar.
      </Text>
      <Button
        data-testid="understood-button"
        fullWidth
        disabled={false}
        onClick={handleCloseBottomSheet}
      >
        Entendi
      </Button>
    </Flex>
  </BottomSheet>
)
